import { render } from "./ResetePassword.vue?vue&type=template&id=bce00684&scoped=true"
import script from "./ResetePassword.vue?vue&type=script&lang=js"
export * from "./ResetePassword.vue?vue&type=script&lang=js"

import "./ResetePassword.vue?vue&type=style&index=0&id=bce00684&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bce00684"]])

export default __exports__